import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["BuilderEstimatorHouseCarousel"], {
      showFloorplan: $setup.showFloorplan,
      sliderImages: $props.selectedHouseDesign.mainImages,
      isImageFloorplanModalOpen: $setup.isImageFloorplanModalOpen,
      zoom: $setup.zoom,
      isDesktop: $setup.isDesktop,
      showColorsControls: $setup.showColorsControls,
      showExitInteriorsButton: $setup.showExitInteriorsButton,
      getColorsSelection: $setup.getColorsSelection,
      selectedHouseDesign: $props.selectedHouseDesign,
      onUpdateZoom: $setup.updateZoom,
      onCloseImageModal: $setup.closeImageModal,
      onExitInteriors: $setup.exitInteriors,
      onSelectColor: $setup.onSelectColor
    }, null, 8, ["showFloorplan", "sliderImages", "isImageFloorplanModalOpen", "zoom", "isDesktop", "showColorsControls", "showExitInteriorsButton", "getColorsSelection", "selectedHouseDesign", "onUpdateZoom", "onCloseImageModal", "onExitInteriors", "onSelectColor"]),
    ($setup.isDesktop)
      ? (_openBlock(), _createBlock($setup["BuilderEstimatorHouseFeaturesDesktop"], {
          key: 0,
          currentFeature: $setup.currentFeature,
          house: $setup.house,
          onSetCurrentFeature: $setup.setCurrentFeature
        }, null, 8, ["currentFeature", "house", "onSetCurrentFeature"]))
      : _createCommentVNode("", true)
  ]))
}